var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sb-primary-button sb-button-reset",class:{ 'disabled' : _vm.disabled, 'active': _vm.active },on:{"click":function($event){$event.preventDefault();return _vm.handlePrimaryButtonClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }